import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* settleWithSavings(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_REQUEST
    })

    let requestPayload: any = {};

    if(action.payload?.companyId) {
      requestPayload.companyId = action.payload?.companyId;
    }

    if(action.payload?.description) {
      requestPayload.description = action.payload?.description;
    }

    const res = yield call(Http.post, `charges/${action.payload?.chargeId}/settle-with-savings`, {...requestPayload});

    yield put({
      type: Constants.GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_SUCCESS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchSettleWithSavings() {
  yield takeEvery(Constants.GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_START, settleWithSavings);
}
